// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  catalog: __t.bool(),
  id: __t.string().primaryKey(),
  name: __t.string(),
  ruleset: __t.string(),
  admissionOpen: __t.bool().name("admission_open"),
  formationCount: __t.u32().name("formation_count"),
  live: __t.bool(),
  endpointUrl: __t.string().name("endpoint_url"),
  terrainRevision: __t.string().name("terrain_revision"),
  epoch: __t.u64(),
  authorityNonce: __t.string().name("authority_nonce"),
  leaseUntil: __t.timestamp().name("lease_until"),
  tick: __t.u64(),
  cursor: __t.u64(),
  checkpoint: __t.string(),
});
